export default "__VITE_ASSET__B6s$1Kmd__ 100w";